import { exportDataAtom } from '@src/components/export/atom';
import buildCsv from '@src/components/export/buildCsv';
import { getPercentageMetricByKey } from '@src/utils/metrics/metricHelpers';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

const filterHeaderFooterAndData = (rawData, selected) => {
  const { data, footerData, headers } = rawData;

  // 1. adding pct metric key to selected
  const fullList = ['timestamp'];
  selected.forEach((metric) => {
    fullList.push(metric);
    const pctMetric = getPercentageMetricByKey({ metricKey: metric });
    if (pctMetric !== metric) {
      fullList.push(pctMetric);
    }
  });

  // 2. match selected & headers to get index
  const keepIndex: number[] = [];
  headers.forEach((header, index) => {
    if (fullList.includes(header.key)) {
      keepIndex.push(index);
    }
  });

  // 3. filter footer/header/data by index
  const newData = data.map((array) => array.filter((_, index) => keepIndex.includes(index)));
  const newFooterData = footerData.map((array) =>
    array.filter((_, index) => keepIndex.includes(index)),
  );
  const newHeaders = headers.filter((_, index) => keepIndex.includes(index));

  return {
    ...rawData,
    data: newData,
    footerData: newFooterData,
    headers: newHeaders,
  };
};

export const useOptionsExport = ({ config }) => {
  const data: any = useAtomValue(exportDataAtom);

  const filtered = useMemo(() => {
    const res: any = { sections: {} };
    config.sections.forEach((section) => {
      const sectionData = data.sections[section.key];
      res.sections[section.key] = {};
      const widgetKeys = Object.keys(sectionData);
      if (section.selected !== undefined) {
        widgetKeys.forEach((widgetKey) => {
          const widgetData = sectionData[widgetKey];
          if (widgetKey === 'primary-timeseries' || widgetKey === 'mf-timeseries') {
            res.sections[section.key][widgetKey] = filterHeaderFooterAndData(
              widgetData,
              section.selected,
            );
            return;
          }
          if (widgetKey.startsWith('distribution::') || widgetKey.startsWith('dimension-table::')) {
            const name = widgetKey.split('::')[1];
            if (!section.selected.includes(name)) {
              return;
            }
          }
          res.sections[section.key][widgetKey] = widgetData;
        });
        return;
      }
      res.sections[section.key] = sectionData;
    });
    return res;
  }, [config.sections, data]);

  const triggerDownload = () => {
    buildCsv({ config, data: filtered });
  };

  return {
    triggerDownload,
  };
};
